<template>

	<div class="upcoming-events container-fluid theme-light-blue">
		
		<TitleHeader :subtitle="subtitle" :title="title"></TitleHeader>

		<div class="container">

			<div class="upcoming-event-list">

				<div class="featured-upcoming-events">

					<Event :event="event" :layout="'large'" :key="event.id" v-for="event in featuredEvents"></Event>
				</div>

				<div class="event-list">
					
					<Event :event="event" :layout="'mini'" :key="event.id" v-for="event in miniEvents"></Event>
				</div>

			</div>
			
			<PrimaryButton class="center" v-if="cta" :linkText="cta.linkText" :linkURL="cta.linkURL"></PrimaryButton>
		</div>		
	</div>
	
</template>

<script>
	
	import Event from './Event.vue';
	import TitleHeader from '../Global/TitleHeader.vue';
	import PrimaryButton from '../Global/PrimaryButton.vue';
	
	export default {
		name: 'UpcomingEvents',
		
		props: ['subtitle', 'title', 'featuredEvents', 'miniEvents', 'cta'],
		
		components: {
			TitleHeader,
			PrimaryButton,
			Event
		}
	}
	
</script>